import { VStack, Text, HStack, Button, useColorMode } from '@chakra-ui/react'
import React from 'react'
import { useNavigate } from "react-router-dom"
import { FiHome } from "react-icons/fi"
import { TbError404 } from "react-icons/tb"
import Footer from '../components/Footer'
import { getTokens } from '../config/colorTokens'
import { motion } from 'framer-motion'

const MotionVStack = motion(VStack)

const PageNotFound = () => {
    const navigate = useNavigate()
    const { colorMode } = useColorMode()
    const t = getTokens(colorMode)

    return (
        <MotionVStack 
            h="100vh" 
            spacing={0}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
        >
            <VStack m={0} h="100vh" w="100%" display="flex" alignItems="center" justifyContent="center">
                <HStack>
                    <Text fontSize="5xl"><TbError404 /></Text>
                    <Text fontSize="3xl">|</Text>
                    <Text p={0} fontSize="3xl" fontWeight="bold">Not Found</Text>
                </HStack>
                <Text fontSize="md" fontWeight="medium">The page you're looking for was not found.</Text>
                {/* <Divider w="350px"/> */}
                <Button
                    border="1px"
                    borderRadius="10px"
                    borderColor={t.borderCard}
                    // bg={colorMode === "dark" ? "#2c313d" : "#CACBCD"}
                    bg="none"
                    _hover={{
                        textDecoration: "none",
                        bg: t.hoverBg,
                    }}
                    onClick={() => navigate("/")}
                    leftIcon={<FiHome />}
                >
                    Return To Home
                </Button>
            </VStack>
            <Footer />
        </MotionVStack>
    )
}

export default PageNotFound